import { API_URL } from "@/config/constants";
import axios from "axios";
import { Tokens } from "./auth.types";
const API = `${API_URL}/user`;
export const AUTH_REFRESH_TIMEOUT_MS = 30_000;

export const forgotPassword = async (email: string) => {
    const result = await axios.post(`${API}/password/forgot`, { email });
    return result.data;
};

export const resetPassword = async (data: {
    token: string;
    new_password: string;
}) => {
    const result = await axios.post(`${API}/password/reset`, data);
    return result.data;
};

export const login = async (email: string, password: string) => {
    const result = await axios.post<Tokens>(`${API}/login`, {
        email,
        password,
    });
    return result.data;
};

export const changePassword = async (data: {
    current_password: string;
    new_password: string;
}) => {
    const result = await axios.put(`${API}/password/change`, data);
    return result.data;
};

export const refreshToken = async (refresh_token: string | null) => {
    const result = await axios.post<Tokens>(
        `${API_URL}/token/refresh`,
        { refresh_token },
        { timeout: AUTH_REFRESH_TIMEOUT_MS }
    );
    return result.data;
};
